import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBan, faCheckCircle, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

import {useParams} from "react-router-dom";

export const PayGateResponse = () => {
    const navigate = useNavigate();
    const params = useParams();

    const goBack = () => {
        navigate('/');
    };

    switch (params.id) {
        case "1":
            return (
                <div className="grid justify-content-center align-items-center bg-green-100">
                    <div className="col-12 md:col-6 lg:col-6">
                        <Card
                            className="shadow-2 surface-card"
                            title={
                                <div className="flex align-items-center" style={{color: 'green'}}>
                                    <FontAwesomeIcon icon={faCheckCircle} className="mr-2 text-green-500 text-2xl" />
                                    <span className="text-xl font-semibold">Payment Successful</span>
                                </div>
                            }
                        >
                            <div className="mb-4">
                                <img
                                    src="/img/paygate-logo.png"
                                    alt={"PayGate"}
                                    style={{
                                        height: '60px',
                                        width: 'auto',
                                    }}
                                />
                                <p className="mt-2 text-lg text-gray-700">
                                    Your payment was successful!
                                </p>
                                <p className="mt-2 text-lg text-gray-700">
                                    Your account balance has been updated and should reflect shortly.
                                </p>
                            </div>
                            <div className="mb-4 text-gray-600">
                                <p>Thank you for your top-up.</p>
                            </div>
                            <div className="flex justify-content-end">
                                <Button label="Go to Dashboard" icon="pi pi-user" className="p-button-success" onClick={goBack} />
                            </div>
                        </Card>
                    </div>
                </div>
            );
        case "3":
        case "4":
            return (
                <div className="grid justify-content-center align-items-center bg-orange-100">
                    <div className="col-12 md:col-6 lg:col-6">
                        <Card
                            className="shadow-2 surface-card"
                            title={
                                <div className="flex align-items-center" style={{ color: 'orange' }}>
                                    <FontAwesomeIcon icon={faBan} className="mr-2 text-orange-500 text-2xl" />
                                    <span className="text-xl font-semibold">Payment Cancelled</span>
                                </div>
                            }
                        >
                            <div className="mb-4">
                                <img
                                    src="/img/paygate-logo.png"
                                    alt={"PayGate"}
                                    style={{
                                        height: '60px',
                                        width: 'auto',
                                    }}
                                />
                                <p className="mt-2 text-lg text-gray-700">
                                    Your payment was cancelled.
                                </p>
                                <p className="mt-2 text-lg text-gray-700">
                                    Your balance has not been updated.
                                </p>
                            </div>
                            <div className="mb-4 text-gray-600">
                                <p>If you did not intend to cancel, please try again.</p>
                            </div>
                            <div className="flex justify-content-end">
                                <Button label="Try Again" icon="pi pi-refresh" className="p-button-warning" onClick={goBack} />
                            </div>
                        </Card>
                    </div>
                </div>
            )
        case "0":
        case "2":
        case "5":
        case "7":
            return (
                <div className="grid justify-content-center align-items-center bg-gray-100">
                    <div className="col-12 md:col-6 lg:col-6">
                        <Card
                            className="shadow-2 surface-card"
                            style={{ marginTop: '0', paddingTop: '2rem' }}
                            title={
                                <div className="flex align-items-center" style={{color: 'red'}}>
                                    <FontAwesomeIcon icon={faTimesCircle} className="mr-2 text-red-500 text-2xl" />
                                    <span className="text-xl font-semibold">Payment Declined</span>
                                </div>
                            }
                        >
                            <div className="mb-4">
                                <img
                                    src="/img/paygate-logo.png"
                                    alt={"PayGate"}
                                    style={{
                                        height: '60px',
                                        width: 'auto',
                                    }}
                                />
                                <p className="mt-2 text-lg text-gray-700">
                                    {() => {
                                        switch (params.id) {
                                            case "0":
                                                return "Payment was not done, please contact your admin if in error.";
                                            case "2":
                                                return "Payment was declined.";
                                            case "5":
                                                return "The payment has been received by PayGate but not cleared.";
                                            case "7":
                                                return "Settlement voided";
                                            default:
                                                return "We're sorry, but your payment was declined or encountered an error.";
                                        }
                                    }}
                                </p>
                                <p className="mt-2 text-lg text-gray-700">
                                    Your account balance has not been updated.
                                </p>
                            </div>
                            <div className="mb-4 text-gray-600">
                                <p>Please double-check your payment details and try again.</p>
                                <p>If the issue persists, you may want to contact your bank or try a different payment method.</p>
                            </div>
                            <div className="flex justify-content-end">
                                <Button label="Try Again" icon="pi pi-refresh" className="p-button-warning mr-2" onClick={goBack} />
                            </div>
                        </Card>
                    </div>
                </div>
            )

    }

};